<template>
    <header class="header d-blue-bg">
        <!-- Header Top -->
        <div class="header-top">
            <div class="container">
                <div class="header-inner">
                    <div class="row align-items-center">
                        <div class="col-xl-6 col-lg-7">
                            <div class="header-inner-start">


                                <div class="support d-none d-sm-block">
                                    <p>Need Help? <a :href="'tel:0112984988'">011 2098 778</a></p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-5 d-none d-lg-block">
                            <div class="header-inner-end text-md-end">
                                <div class="ovic-menu-wrapper">
                                    <ul>
                                        <li><router-link to="/about">About Us</router-link></li>
                                        <li><router-link to="/contact">Order Tracking</router-link></li>
                                        <li><router-link to="/contact">Contact Us</router-link></li>
                                        <li><router-link to="/faq">FAQs</router-link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- header mid -->

        <div class="header-mid">
            <div class="container">
                <div class="header-mid-inner">
                    <div class="row align-items-center">
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                            <div v-if="!style_3" class="header__info">
                                <div class="logo">
                                    <router-link to="/" class="logo-image">
                                        <img :src="logo" alt="logo">
                                    </router-link>
                                </div>
                            </div>
                            <div v-if="style_3" class="header__info header__info-2">
                                <div class="logo logo-3">
                                    <router-link to="/" class="logo-image">
                                        <img src="/images/logo/logo1.svg" alt="logo">
                                    </router-link>
                                </div>
                                <div class="side-menu mr-20">
                                    <button @click="handleOpenSidebar" type="button"
                                        class="side-menu-btn offcanvas-toggle-btn"><i class="fas fa-bars"></i></button>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-5 col-lg-4 d-none d-lg-block">
                            <div class="header__search">
                                <form @submit.prevent="handleSubmit">
                                    <div class="header__search-box">
                                        <input :class="`search-input ${style_2 ? 'search-input-2' : ''}`" type="text"
                                            placeholder="I'm shopping for..." v-model="searchText" />
                                        <button
                                            :class="`button ${style_2 ? 'button-2' : ''} ${style_3 ? 'button-3' : ''}`"
                                            type="submit">
                                            <i class="fas fa-search"></i>
                                        </button>
                                    </div>
                                    <div class="header__search-cat">
                                        <ui-nice-select :options="category_options" v-model="category_value"
                                            name="Category" :default-current="0" @onChange="changeHandler" />
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-5 col-md-8 col-sm-8">
                            <div class="header-action">
                                <div class="block-userlink">
                                    <router-link :class="`icon-link ${style_2 ? 'icon-link-2' : ''}`" v-if="isLoggedIn"
                                        to="/my-account">
                                        <i class="flaticon-user"></i>
                                        <span class="text welcome-text">
                                            <span class="sub">Welcome, </span>
                                            {{ user.name }} <!-- Show logged-in user's name -->
                                        </span>
                                    </router-link>
                                    <router-link :class="`icon-link ${style_2 ? 'icon-link-2' : ''}`" v-else
                                        to="/login">
                                        <i class="flaticon-user"></i>
                                        <span class="text">
                                            <span class="sub">Login </span>
                                        </span>
                                    </router-link>
                                </div>

                                <!-- <div class="block-wishlist action">
                                    <router-link :class="`icon-link ${style_2 ? 'icon-link-2' : ''}`" to="/wishlist">
                                        <i class="flaticon-heart"></i>
                                        <span class="text">
                                            <span class="sub">Favorite</span>
                                            My Wishlist
                                        </span>
                                    </router-link>
                                </div> -->

                                <div class="block-cart action">
                                    <router-link :class="`icon-link ${style_2 ? 'icon-link-2' : ''}`" to="/cart">
                                        <i class="flaticon-shopping-bag"></i>
                                        <span :class="`count ${style_2 ? 'count-2' : ''}`">
                                            {{ cartStore.totalPriceQuantity.quantity }}
                                        </span>
                                        <span class="text">
                                            <span class="sub">Your Cart:</span>
                                            LKR {{ cartStore.totalPriceQuantity.total.toFixed(2) }}
                                        </span>
                                    </router-link>
                                    <div class="cart">
                                        <header-cart-mini />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- header mid -->

        <div class="header__bottom">
            <div class="container">
                <div class="row g-0 align-items-center">
                    <div class="col-lg-3">

                        <div class="cat__menu-wrapper side-border d-none d-lg-block" @click.stop>
                            <div class="cat-toggle">
                                <button @click.stop="toggleCateMenu" type="button"
                                    class="cat-toggle-btn cat-toggle-btn-1">
                                    <i class="fas fa-bars"></i> Shop by department
                                </button>
                                <div class="cat__menu" v-show="cate_menu" @click.stop>
                                    <nav id="mobile-menu">
                                        <header-category :categories="category_data"></header-category>
                                    </nav>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="col-lg-6 col-md-6 col-3">
                        <div class="header__bottom-left d-flex d-xl-block align-items-center">
                            <div class="side-menu d-lg-none mr-20">
                                <button @click="isSidebarOpen = !isSidebarOpen" type="button"
                                    class="side-menu-btn offcanvas-toggle-btn">
                                    <i class="fas fa-bars"></i>
                                </button>
                            </div>
                            <div class="main-menu d-none d-lg-block">
                                <header-nav-menu></header-nav-menu>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="col-lg-3 col-md-6 col-9">
                        <div class="shopeing-text text-sm-end">
                            <p>Spend $120 more and get free shipping!</p>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </header>
</template>

<script>
//import logo from '@/assets/logo/logo1.svg'
import logo from '@/assets/img/logo.png'
import HeaderNavMenu from '@/components/test/HeaderNavMenu.vue'
import UiNiceSelect from '@/components/ui/nice-select.vue'
import HeaderCartMini from '@/components/test/header-cart-mini.vue'
import HeaderCategory from '@/components/test/header-category.vue'
import { useCartStore } from '@/stores/useCartStore'
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue'

export default {
    components: {
        HeaderNavMenu,
        UiNiceSelect,
        HeaderCategory,
        HeaderCartMini
    },
    name: "HeaderOne",
    setup() {
        const user = ref(JSON.parse(localStorage.getItem('user')) || null) // Get user from localStorage
        const isLoggedIn = computed(() => {
            return !!user.value // Check if the user data exists
        })

        watch(() => localStorage.getItem('user'), (newVal) => {
            user.value = JSON.parse(newVal)
        })
        const cartStore = useCartStore()

        const cate_menu = ref(false)

        // Toggle menu when clicking the button
        const toggleCateMenu = () => {
            cate_menu.value = !cate_menu.value
        }

        // Close menu when clicking outside
        const closeCateMenu = (event) => {
            const menuWrapper = document.querySelector('.cat__menu-wrapper')
            if (menuWrapper && !menuWrapper.contains(event.target)) {
                cate_menu.value = false
            }
        }

        // Attach and detach global event listeners
        onMounted(() => {
            document.addEventListener('click', closeCateMenu)
        })

        onBeforeUnmount(() => {
            document.removeEventListener('click', closeCateMenu)
        })



        return {
            user,
            isLoggedIn,
            cartStore,
            logo,
            cate_menu,
            toggleCateMenu

        }
    },
    data() {
        return {
            isSidebarOpen: false,
            category_data: [],
            searchText: '',
            category_value: '',
            category_options: [],
        }
    },
    methods: {
        async fetchCategories() {
            try {
                const response = await this.$axios.get('/web-item-categories')
                this.category_data = response.data
                this.category_options = this.category_data.map(item => {
                    return { value: item.id, text: item.name }
                })
                this.category_options.unshift({ value: "all", text: "All Category" })
            } catch (error) {
                console.error("Error fetching categories:", error)
            }
        },
        changeHandler(value) {
            //console.log('Category changed:', value)
            this.category_value = value.value
        },

        handleSubmit() {
            if (this.searchText && this.category_value) {
                this.$router.push(`/search?searchText=${this.searchText}&category=${this.category_value}`)
            } else if (this.searchText) {
                this.$router.push(`/search?searchText=${this.searchText}`)
            } else if (this.category_value) {
                this.$router.push(`/search?category=${this.category_value}`)
            } else {
                this.$router.push(`/search`)
            }
        }
    },
    mounted() {
        this.fetchCategories()
    }
}
</script>


<style>
.header-mid-inner {
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.1) !important;
    padding: 10px 0 !important;
    position: relative !important;
    z-index: 2 !important;
}

.header__search-box {
    border: 2px solid #000;
    border-radius: 6px;
}

.header-mid {
    background: #fff;

}

.header-action .icon-link span {
    color: #000
}

.header-action .icon-link i {
    color: #000
}

.header-action .icon-link .sub {
    color: #000
}

.header-action .icon-link i.flaticon-user {
    color: #000
}

.header-action .icon-link i.flaticon-shopping-bag {
    color: #000
}

.header-action .icon-link i.flaticon-user .text {
    color: #000
}

.welcome-text {
    color: #000 !important
}

/*
.d-black-bg{
    background-color:#CC1414;
}

.header .header__bottom{
    background:#2d3192
}
.header__search-box .button{
    color:#fff
}
   */
</style>
